module.exports = ".map {\n  height: 500px;\n  width: 100%;\n}\n\n.map-container {\n  height: 500px;\n  width: 100%;\n  padding: 0px;\n}"